module.exports = __webpack_public_path__ + "img/xh.8b15d4c8.jpg";